import './dashAdmin.css';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import { appFirebase, messaging } from '../../firebase/credenciales.js';
import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { io } from 'socket.io-client';
import { urlServer } from '../../config.js';
import { onMessage } from 'firebase/messaging';
import Swal from "sweetalert2";


import Header from './header.jsx';
import Sidebar from './sidebar.jsx';

// main-content
import Index from './main-content/index.jsx';
import Users from './main-content/users.jsx';
import Sorteos from './main-content/sorteos.jsx';
import Money from './main-content/money.jsx';
import Notificaciones from './main-content/notificaciones.jsx';
import MegaLotoExpress from './main-content/plantillaWhatsapp.jsx';
import SorteoExpress from './main-content/SorteoExpress.jsx'

const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);

const DashAdmin = () => {
  const [dataEmpresa, setDataEmpresa] = useState(null);
  const [dataUser, setDataUser] = useState(null);
  const [board, setBoard] = useState('index');
  const [dataNequi, setDataNequi] = useState([]); // Cargas Nequi data
  const [dataUsers, setDataUsers] = useState([]);
  const [socket, setSocket] = useState(null);
  const [dataSorteos, setDataSorteos] = useState([]); // Sorteos data
  const [dataBoard, setDataBoard] = useState()

  // Función para extraer colección desde Firestore
  const extraerColeccion = (nombreColeccion, callback) => {
    try {
      const coleccionRef = collection(db, nombreColeccion);
      onSnapshot(coleccionRef, (snapshot) => {
        const datosColeccion = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        if (callback) {
          callback(datosColeccion);
        }
      });
    } catch (error) {
      console.error("Error al extraer la colección:", error);
    }
  };

  // Función para escuchar datos de usuarios a través del socket
  const extraerUsers = (socket) => {
    // socket.on('dataUsers', (data) => {
    //   console.log('Se recibió dataUsers');
    //   setDataUsers(data); // Actualiza el estado con la nueva data
    // });

    // Evento adicional para escuchar nuevas conexiones de usuarios
    socket.on('newUser', () => {
      console.log('Nuevo usuario registrado');
    });

    // Escuchar actualización de los datos de usuario
    // socket.on('dataUserUpdate', (data) => {
    //   console.log('Datos de usuario actualizados');
    //   setDataUsers(data); // Actualiza los datos de usuarios
    // });
  };

  // Función para escuchar otras novedades
  const EscuchaNovedades = (socket) => {
    socket.on('NewRecargaCuenta', () => {
      console.log('Nueva solicitud de recarga de cuenta');
    });
    socket.on('fechaInicioSorteo',(fecha)=>{
      console.log(fecha)
      Swal.fire(`fecha asignada correctamente: ${fecha}`)
  })
    // socket.on('newSaldo', (data) => {
    //   console.log('Se realizó una compra', data);
    //   setDataUsers(data.users)
    // });
  };

  useEffect(() => {
    //notificaciones
    onMessage(messaging,(payload)=>{
      console.log(payload)
      // Swal.fire
      Swal.fire({
        title: payload.notification.title,
        text: payload.notification.body,
        imageUrl: payload.notification.image,
        imageWidth: 400,
        imageHeight: 400,
        imageAlt: 'imagen de notificacion',
        confirmButtonText: 'Aceptar'
      })
    })


    // Extraer datos de la colección 'empresa'
    extraerColeccion('empresa', (data) => {
      setDataEmpresa(data[0]);
    });
    extraerColeccion("sorteos", (datos) => {
      setDataSorteos(datos);
    });
    extraerColeccion("CargaNequi", (datos) => {
      setDataNequi(datos);
    });
    extraerColeccion("users", (datos) => {
      setDataUsers(datos);
    });

    // Obtener los datos del usuario autenticado
    onAuthStateChanged(auth, (user) => {
      setDataUser(user);
    });

    // Establecer la conexión del socket cuando el componente se monta
    const newSocket = io(urlServer, {
      reconnection: true,   // Habilita la reconexión automática
      reconnectionAttempts: 5,  // Número de intentos de reconexión
      reconnectionDelay: 1000,  // Retraso en ms entre intentos de reconexión
    });
    setSocket(newSocket);

    // Escuchar datos de usuarios a través del socket
    extraerUsers(newSocket);
    EscuchaNovedades(newSocket);

    // Verificar si el socket se desconecta
    newSocket.on('disconnect', () => {
      console.log('Socket desconectado');
    });

    // Limpiar la conexión del socket al desmontar el componente
    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  return (
    <div className="dashAdmin">
      {dataEmpresa && (
        <Header dataEmpresa={dataEmpresa} dataUser={dataUser} />
      )}
      <div className="main">
        <Sidebar board={setBoard} />
        <div className="main-content" style={{ backgroundImage: `url('./fondo.jpg')` }}>
          {/* Puedes activar estas secciones cuando las necesites */}
          {board === 'index' && <Index dataUsers={dataUsers} dataSorteos={dataSorteos} socket={socket}/>}
          {board === 'users' && <Users dataUsers={dataUsers} socket={socket} />}
          {board === 'sorteos' && <Sorteos dataSorteos={dataSorteos} socket={socket} board={{setBoard, setDataBoard}} />}
          {board === 'money' && <Money dataNequi={dataNequi} dataUsers={dataUsers} socket={socket} />}
          {board === 'notificaciones' && <Notificaciones socket={socket} />}
          {board === 'plantillaWhatsapp' && <MegaLotoExpress sorteos={dataSorteos} dataUsers={dataUsers} sorteodata={dataBoard}/>}
          {board === 'agregarExpress' && <SorteoExpress 
            dataInfo={{
              data:{
                sorteo:dataBoard,
                dataSorteos
              },
              socket
            }}/>}
                    {/* {board === 'promos' && <Promos />} */}
          {/* {board === 'reports' && <Reports />} */}
          {/* {board === 'soport' && <Soport />} */}
        </div>
      </div>
    </div>
  );
};

export default DashAdmin;
